module.exports = __webpack_public_path__ + "static/media/home-dark.a6b594c2.svg";